import { Observable, map } from 'rxjs';

export const assertDefined: <T>(value: T | undefined | null, error?: string) => asserts value is T = <T>(
	value: T | undefined | null,
	error?: string,
) => {
	if (typeof value === 'number' || typeof value === 'boolean') {
		return;
	}

	if (!value) {
		throw new Error(error || 'Value is not defined');
	}
};

export function assertTrue(value: boolean, error?: string): asserts value is true {
	if (!value) {
		throw new Error(error || 'Value is falsy');
	}
}

/**
 * Transforms an observable of a nullable type into an observable of a non-nullable type.
 * @param value
 * @returns
 */
export const assertDefined$ = <T>(value: Observable<T | undefined | null>) => {
	return value.pipe(
		map((v) => {
			assertDefined(v);
			return v;
		}),
	);
};
